import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorPaymentImportNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IPaymentImportModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IPaymentImportFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function usePaymentImportHookNae(id: number) : IPaymentImportModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorPaymentImportNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.PaymentImport.schema,
        fields: IPaymentImportFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
